import { ChangeDetectionStrategy, Component, Input, Renderer2, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FlipComponent = /** @class */ (function () {
    function FlipComponent(renderer) {
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    FlipComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.rotate();
    };
    /**
     * @param {?} change
     * @return {?}
     */
    FlipComponent.prototype.ngOnChanges = /**
     * @param {?} change
     * @return {?}
     */
    function (change) {
        this.rotate();
    };
    /**
     * @return {?}
     */
    FlipComponent.prototype.rotate = /**
     * @return {?}
     */
    function () {
        if (this.flip) {
            this.renderer.addClass(this.flipContainer.nativeElement, 'rotate');
        }
        else {
            this.renderer.removeClass(this.flipContainer.nativeElement, 'rotate');
        }
    };
    FlipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-flip',
                    template: "<div class=\"flipper\" #flipContainer>\n<div class=\"front\">\n  <ng-content select=\"[front]\" ></ng-content>\n</div>\n  <div class=\"back\">\n  <ng-content select=\"[back]\" ></ng-content>\n  </div>\n</div>\n\n",
                    styles: [":host{-webkit-perspective:1000px;perspective:1000px;display:block}:host .flipper{transition:.6s;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;height:100%;width:100%;position:relative}:host .back,:host .front{width:100%;height:100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;position:absolute;top:0;left:0}:host .front{z-index:2;-webkit-transform:rotateY(0);transform:rotateY(0)}:host .back{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}:host .rotate{-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}"],
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    FlipComponent.ctorParameters = function () { return [
        { type: Renderer2 }
    ]; };
    FlipComponent.propDecorators = {
        flipContainer: [{ type: ViewChild, args: ['flipContainer',] }],
        flip: [{ type: Input }]
    };
    return FlipComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var FlipModule = /** @class */ (function () {
    function FlipModule() {
    }
    FlipModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        FlipComponent
                    ],
                    declarations: [FlipComponent]
                },] },
    ];
    return FlipModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { FlipComponent, FlipModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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